import script from "./AnimatedBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedBackground.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedBackground.vue?vue&type=style&index=0&id=57a7db52&lang=scss"

const __exports__ = script;

export default __exports__